<template>
	<div>
		<aeg-case-home
			:caseViews="caseViews"
			addProposalButtonText="Add Jewellers Exhibition Proposal"
			productTypeLabel="Type"
			selectProductInsuranceType="jewellers_exhibition"
			:offerHasMultipleLayers="true"
		></aeg-case-home>
	</div>
</template>

<script>
import AegCaseHome from "./AegCaseHome"

export default {
	components: {
		AegCaseHome
	},
	data() {
		return {
			caseViews: {
				default_view: "AegCaseJewellersExhibition"
			}
		}
	}
}
</script>
